/* eslint-disable react/jsx-pascal-case */
import { useState, lazy, useEffect } from 'react'
import { Routes, Route } from "react-router-dom";
import LoginForm from '../login/Login';
import useWindowDimensions from './useWindowDimensions';
import Cookies from 'js-cookie';
import '../../App.css';
import LoginPopup from '../login/loginpopup';

import RegistrationForm from '../signup/RegistrationForm';
// "dev-build": "set GENERATE_SOURCEMAP=false env-cmd -e dev react-scripts build",
const ForgotPassword = lazy(() => import('../login/PasswordResetEmail'))
const SelfAssessment = lazy(() => import('./self-assessment/Self-assessment'));
const Dashboard = lazy(() => import('./Dashboard'))
const Sidebar = lazy(() => import('./Sidebar'));
const TabNavbar = lazy(() => import('./TabNavbar'))
const Appbar = lazy(() => import('./Appbar'));
const Details = lazy(() => import('./details/Details'));
const Frameworks = lazy(() => import('./self-assessment/Frameworks'));
const AuditHeader = lazy(() => import('./self-assessment/AuditHeader'))
const ProcessPage = lazy(() => import('./self-assessment/process/ProcessMainPage'))
const Profile = lazy(() => import('./User_Profile/Profile'))
const ChangePassword = lazy(() => import('./User_Profile/ChangePassword'))
const QuestionsPage = lazy(() => import('../tool/self-assessment/ControlList'))
const Settings = lazy(() => import('../tool/Settings'))

const UserAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [sidebarExpanded, setSidebarExpanded] = useState(false)
    var sidebarChangeExpanded = ''
    var sidebarChangeUnexpanded = ''
    const { width } = useWindowDimensions()
    const [showDetails, setShowDetails] = useState(false)
    const updateSidebarStatus = (value) => {
        setSidebarExpanded(value)
    }
    const UpdateShowDetails = (newVal) => {
        setShowDetails(newVal)
    }
    // useEffect(() => {
    //     // Load chatbot script dynamically when user logs in
    //     if (isAuthenticated) {
    //       const script = document.createElement('script');
    //       script.src = '//in.fw-cdn.com/31846470/963590.js'; // Replace with your chatbot script URL
    //       script.async = true;
    //       script.chat = true;
    //       document.body.appendChild(script);
    
    //       // Clean up function to remove the script when component unmounts (optional)
    //       return () => {
    //         document.body.removeChild(script);
    //       };
    //     }
    //   }, [isAuthenticated]);
    
    useEffect(() => {
        if (isAuthenticated) {
          // Create and configure the new script element
          const script = document.createElement('script');
          script.src = '//in.fw-cdn.com/32005772/1060785.js'; // New chatbot script URL
          script.async = true;
          script.setAttribute('chat', 'true');
          
          // Append the script to the body
          document.body.appendChild(script);
    
          // Clean up function to remove the script when component unmounts
          return () => {
            document.body.removeChild(script);
          };
        }
      }, [isAuthenticated]);
    
    useEffect(() => {
        const checkAuthentication = () => {
            const cookieValue = Cookies.get("isAuthenticated");
            // Update the state variable based on the value of the authentication cookie
            setIsAuthenticated(cookieValue === "true");
          };
      
          // Call the checkAuthentication function initially
          checkAuthentication();
      
          // Set up an interval to periodically check for changes in the authentication cookie
          const intervalId = setInterval(checkAuthentication, 1000);
      
          // Clean up the interval when the component unmounts
          return () => clearInterval(intervalId);
    })

    if(width > 1300){
        sidebarChangeExpanded = 'sidebar_expanded'
        sidebarChangeUnexpanded = 'sidebar_collapsed'
    }else{
        sidebarChangeExpanded = 'tab_sidebar_expanded'
        sidebarChangeUnexpanded = 'tab_sidebar_collapsed'
    }
    return(
        <>
            {isAuthenticated ? (
            <div style={{overflow:"hidden"}}>
                <div className='sidebar_and_appbar'>
                    {width > 0 ? (<Sidebar updateSidebarStatus={updateSidebarStatus} />) : (<TabNavbar/>) }
                    
                </div>
                <div className={
                        sidebarExpanded 
                            ? `content ${sidebarChangeExpanded}`
                            : width < 1200 
                                ? 'tab_content'
                                : `content ${sidebarChangeUnexpanded}`
                }
                >

                    <Routes>
                        <Route path="/" element={<Dashboard/>}/>
                        <Route path="/details" element={<Details UpdateShowDetails={UpdateShowDetails}/>}/>
                        <Route path="/self-assessment" element = {<SelfAssessment sidebarExpanded = {sidebarExpanded}/>}/>
                        <Route path="/self-assessment/choose-frameworks" element={<Frameworks/>} />
                        <Route path="/self-assessment/choose-frameworks/auditheader" element={<AuditHeader/>} />
                        <Route path="/profile" element={<Profile/>} />
                        <Route path="/changepassword" element={<ChangePassword/>} />
                        <Route path="/self-assessment/choose-frameworks/auditheader/process" element={<ProcessPage/>} />
                        <Route path="/self-assessment/choose-frameworks/auditheader/process/questionpage" element={<QuestionsPage/>} />
                        <Route path="/settings" element={<Settings/>} />
                        {/* <Route path="/loginpopup" element={<LoginPopup/>} /> */}
                       

                    </Routes>
                </div>
            </div>
           ) : (
            <>
            <Routes>
                <Route path="/ForgotPassword" element={<ForgotPassword/>}/>
                <Route path="/" element={<LoginForm/>}/>
                <Route path="/register" element={<RegistrationForm/>}/>
            </Routes>
           </>
           )
        }
        </>
    )
}

export default UserAuth